export default __webpack_public_path__ + "static/media/user-profile-black.dd875f66.svg";